'use client';
import { Skeleton } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { WidgetContainer } from '@/components/modules/Widget/Container';
import { useGetTopContent } from '@/modules/Entertainment/http/client/useGetTopContent';
import { IfRender } from '@/utils/jsx';
import { TopContentCard } from './Card';

const TOP_CONTENT_ID = 'TopContent';

export const TopContentWidget = () => {
  const t = useT();

  const { data: topContent = [], isLoading } = useGetTopContent();

  return (
    <IfRender condition={topContent.length > 0}>
      <WidgetContainer
        containerId={TOP_CONTENT_ID}
        title={t('widgets.TopContentWidget.title')}
        darkMode
        containerTitleProps={{
          mt: '2rem',
          color: 'content.alwaysLight',
        }}
        containerProps={{
          px: '2.75rem',
          py: '2rem',
          bg: 'background.alwaysDark',
          color: 'content.alwaysLight',
        }}
        containerSxProps={{
          '>div': { top: 8, '>div': { _first: { pr: 8 } } },
          '.swiper-slide': { h: '19.625rem', _last: { pr: 8 } },
          [`.slide-prev-${TOP_CONTENT_ID}`]: {
            boderColor: 'border.primary',
            svg: {
              color: 'content.brandLight',
            },
            _hover: {
              bg: 'transparent',
            },
          },
          [`.slide-next-${TOP_CONTENT_ID}`]: {
            boderColor: 'border.primary',
            svg: {
              color: 'content.brandLight',
            },
            _hover: {
              bg: 'transparent',
            },
          },
        }}
        sliderProps={{ slidesGap: 32, swiperGap: '30px' }}
      >
        {isLoading
          ? Array.from({ length: 10 }).map((_, idx) => (
              <Skeleton
                w="20.625rem"
                h="19.625rem"
                borderRadius="0.3125rem"
                key={idx}
              />
            ))
          : topContent.map(
              ({ id, program_title, published_at, slug, thumb, title }, i) => (
                <TopContentCard
                  key={id}
                  thumb={thumb}
                  title={title}
                  path={slug}
                  position={i + 1}
                  programTitle={program_title}
                  publishedAt={published_at}
                />
              )
            )}
      </WidgetContainer>
    </IfRender>
  );
};
